import React from 'react';
import PageMeta from '../components/common/PageMeta';
import CtaTwo from '../components/cta/CtaTwo';
import Team from '../components/team/Team';
import TestimonialTwo from '../components/testimonial/TestimonialTwo';
import Navbar from '../layout/Header/Navbar';
import Layout from '../layout/Layout';
import Footer from "../components/Home/Footer";
import AboutPageHero from "./infrastructure/AboutPageHero";
import OurStory from "./infrastructure/OurStory";
import FeatureImgThree from "./infrastructure/FeatureImgThree";

const Infrastructure = () => {
  return (
    <Layout>
      <PageMeta title='Sunlex' />
      <Navbar classOption='navbar-light' />
      <AboutPageHero />
      {/*<OurStory />*/}
      <FeatureImgThree />
      <Footer/>
    </Layout>
  );
};

export default Infrastructure;
